import { message } from "antd";
import { I18n } from "react-redux-i18n";

export async function handleGenericApiError(err) {
  try {
    if (err === "DATE_FILTER_ERROR") {
      return message.error(I18n.t("errors.DATE_FILTER_ERROR"));
    }

    if (err?.response?.status === 403) {
      return message.error(I18n.t("errors.PERMISSION_DENIED"));
    }

    if (err.response.status === 500) {
      return message.error(I18n.t("errors.GENERIC"));
    }

    if (err.response.status === 401) {
      message.destroy();
      return message.error("Sua sessão expirou");
    }

    if (err.response.data.error?.message) {
      return message.error(I18n.t(`errors.${err.response.data.error.message}`));
    }
    if (err.response.data.message) {
      if (
        err.response.data.message === "BACKOFFICE_USER_NOT_FOUND" &&
        window.location.pathname === "/"
      ) {
        return message.error(I18n.t(`errors.INVALID_CREDENTIALS`));
      }
      return message.error(I18n.t(`errors.${err.response.data.message}`));
    } else {
      message.error(I18n.t("errors.GENERIC"));
    }
  } catch (error) {
    try {
      return message.error(I18n.t(`errors.${err.response.data.message}`));
    } catch (error) {
      return message.error(I18n.t("errors.GENERIC"));
    }
  }
}
